import React from "react";

import Tooltip from "@material-ui/core/Tooltip";

import { Link, withRouter } from "react-router-dom";

import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";

import BaseTable from "./BaseTable";
import StatesTable from "./StatesTable";

import View from "./cells/View";
import Declaration from "../modal/Declaration";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";
import General from "../../../utils/General";
import Declarant from "../../../utils/Declarant";

const CREATOR_FILTERS = {
  name: {
    api: "company_id",
    display: "Company",
  },
  endpoint: {
    url: `${window.Api.Companies}`,
    filters: "",
    orderBy: "name",
    accessor: "",
  },
};

const STATUS_FILTERS = {
  isMulti: true,
  name: {
    api: "statuses",
    display: "Status",
  },
  values: [
    {
      label: "Draft",
      value: "draft",
    },
    {
      label: "Complete",
      value: "complete",
    },
    {
      label: "Processing",
      value: "processing",
    },
    {
      label: "Registered",
      value: "registered",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
    {
      label: "Accepted",
      value: "accepted",
    },
    {
      label: "Under Review",
      value: "under_review",
    },
    {
      label: "Insufficient Funds",
      value: "insufficient_funds",
    },
    {
      label: "Not Released",
      value: "not_released",
    },
    {
      label: "Not Released For Export",
      value: "not_released_for_export",
    },
    {
      label: "Export Stopped At Exit",
      value: "export_stopped_at_exit",
    },
    {
      label: "Released",
      value: "released",
    },
    {
      label: "Released For Export",
      value: "released_for_export",
    },
  ],
};

const ROUTE_FILTERS = {
  isMulti: true,
  name: {
    api: "routes",
    display: "Route",
  },
  values: [
    {
      label: "Red",
      value: "red",
    },
    {
      label: "Green",
      value: "green",
    },
    {
      label: "Orange",
      value: "orange",
    },
    {
      label: "Yellow",
      value: "yellow",
    },
  ],
};

const CONSIGNOR_FILTERS = {
  isMulti: true,
  name: {
    api: "consignor_ids",
    display: "Consignor",
  },
  endpoint: {
    url: `${window.Api.Parties}`,
    filters: "type=exporter",
    accessor: "",
  },
};

const CONSIGNEE_FILTERS = {
  isMulti: true,
  name: {
    api: "consignee_ids",
    display: "Consignee",
  },
  endpoint: {
    url: `${window.Api.Parties}`,
    filters: "type=importer",
    accessor: "",
  },
};

const CLIENT_FILTERS = {
  isMulti: true,
  name: {
    api: "client_ids",
    display: "Client",
  },
  endpoint: {
    url: `${window.Api.Parties}`,
    filters: "type=client",
    accessor: "",
  },
};

const SUBTYPE_FILTERS = {
  isMulti: true,
  name: {
    api: "form_subtypes",
    display: "Sub Type",
  },
  values: [
    {
      label: "H1",
      value: "H1",
    },
    {
      label: "H2",
      value: "H2",
    },
    {
      label: "H3",
      value: "H3",
    },
    {
      label: "H4",
      value: "H4",
    },
    {
      label: "H5",
      value: "H5",
    },
    {
      label: "H6",
      value: "H6",
    },
    {
      label: "H7",
      value: "H7",
    },
    {
      label: "I1",
      value: "I1",
    },
    {
      label: "G3/G4",
      value: "G4G3",
    },
    {
      label: "B1",
      value: "B1",
    },
    {
      label: "B2",
      value: "B2",
    },
    {
      label: "B4",
      value: "B4",
    },
    {
      label: "BIRDS",
      value: "BIRDS",
    },
    {
      label: "C1 C&F",
      value: "C1 C&F",
    },
    {
      label: "C1 B&E",
      value: "C1 B&E",
    },
    {
      label: "F10",
      value: "F10",
    },
    {
      label: "F11",
      value: "F11",
    },
    {
      label: "F50",
      value: "F50",
    },
  ],
};

const FILTERS = [
  CREATOR_FILTERS,
  STATUS_FILTERS,
  ROUTE_FILTERS,
  CONSIGNOR_FILTERS,
  CONSIGNEE_FILTERS,
  CLIENT_FILTERS,
  SUBTYPE_FILTERS,
];

class LinkedSubmissionsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      live: props.live,
      mode: props.mode,
      imports: props.imports,
      expandedSubmissionIds: [],
    };

    this.table = React.createRef();
    this.statesTable = React.createRef();
  }

  _goTo(submission, edit = true) {
    this.setState({
      selectedSubmission: submission,
      declarationEditable: edit,
      showDeclarationModal: true,
    });
  }

  _collapse(submission) {
    let { expandedSubmissionIds } = this.state;
    let newExpandedSubmissionIds = expandedSubmissionIds.filter(
      (submissionId) => submission.id !== submissionId
    );
    this.setState({ expandedSubmissionIds: newExpandedSubmissionIds });
  }

  _expand(submission) {
    let { expandedSubmissionIds } = this.state;
    this.setState({
      expandedSubmissionIds: [...expandedSubmissionIds, submission.id],
    });
  }

  _isExpanded(submission) {
    let { expandedSubmissionIds } = this.state;

    return (
      expandedSubmissionIds.find(
        (submissionId) => submission.id == submissionId
      ) != null
    );
  }

  _getLastUpdatedBy(submission) {
    let updatedBy = Declarant.getCustomsName(submission.form);
    let state = submission.latest_state;
    if (state.company_member) {
      let user = state.company_member.user;
      updatedBy = `${user.first_name} ${user.last_name}`;
    }
    return updatedBy;
  }

  _renderRoute(submission) {
    let className = "";
    if (submission.route === "green") {
      className = "svg-icon-light-success";
    } else if (submission.route === "red") {
      className = "svg-icon-light-danger";
    } else if (submission.route === "yellow") {
      className = "svg-icon-light-yellow";
    } else if (submission.route === "orange") {
      className = "svg-icon-light-orange";
    }

    let route = (
      <span className={`svg-icon ${className}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
        >
          <circle fill="currentColor" cx="12" cy="12" r="8"></circle>
        </svg>
      </span>
    );

    if (
      ["draft", "complete", "processing", "rejected"].indexOf(
        submission.status
      ) > -1
    ) {
      route = null;
    }

    return route;
  }

  _renderSubmissionDetailColumn(title, subtitle, text) {
    return (
      <>
        <h4 className="text-muted fw-normal">{title}</h4>
        <p className="text-primary fw-light mb-0">{subtitle}</p>
        <p className="text-muted fw-light mb-0">{text}</p>
      </>
    );
  }

  _renderSubmission(submission, selected = false) {
    let route = this._renderRoute(submission);
    let showStatesTable = this._isExpanded(submission);
    let lastUpdatedBy = this._getLastUpdatedBy(submission);

    let className = "card card-submission";

    if (selected) {
      className += " card-submission-selected";
    }

    return (
      <>
        <div
          className={className}
          onClick={() => {
            if (this._isExpanded(submission)) {
              this._collapse(submission);
            } else {
              this._expand(submission);
            }
          }}
        >
          <div className="row">
            <div className="col-8 ids">
              {General.snakeCaseToTitleCase(submission.status)} {route}
              <div className="content">
                <h4 className="text-primary">ID: {submission.id}</h4>
                <h5 className="text-muted">MRN: {submission.mrn}</h5>
                <span className="text-muted fw-bold d-block fs-8">
                  {submission.external_id && (
                    <span className="text-muted fw-bold text-muted d-block fs-8">
                      UCR: <span>{submission.external_id} </span>
                    </span>
                  )}
                </span>
            </div>
          </div>
          <div className="col-4 text-end">
            <span className="text-dark text-hover-primary fs-6">
              <View
                onViewClicked={(e) => {
                  e.stopPropagation();
                  this._goTo(submission);
                }}
              />
            </span>
          </div>
        </div>
          <hr />
          <div className="row mt-2" />
          <div className="row">
            <div className="col-3">
              {this._renderSubmissionDetailColumn(
                "Consignor",
                submission.consignor?.name,
                submission.consignor?.identification_number
              )}
            </div>

            <div className="col-3">
              {this._renderSubmissionDetailColumn(
                "Consignee",
                submission.consignee?.name,
                submission.consignee?.identification_number
              )}
            </div>

            <div className="col-3">
              {this._renderSubmissionDetailColumn(
                "Type",
                submission.form.subtype,
                submission.form.type.toUpperCase()
              )}
            </div>

            <div className="col-3">
              {this._renderSubmissionDetailColumn(
                "Last Update",
                lastUpdatedBy,
                moment(submission.latest_state.created_at).format("lll")
              )}
            </div>
          </div>
        </div>

        <div className="w-100 pt-3 inner-states-table-container">
          {showStatesTable && (
            <>
              <StatesTable
                submission={submission}
                submissionID={submission.id}
                compact={true}
              />
            </>
          )}
        </div>
      </>
    );
  }

  _getColorClassNameForRoute(route) {
    let className = "secondary";
    if (route === "green") {
      className = "success";
    } else if (route === "red") {
      className = "danger";
    } else if (route === "yellow") {
      className = "yellow";
    } else if (route === "orange") {
      className = "orange";
    }
    return className;
  }

  _getColumns() {
    return [
      {
        Header: "",
        id: "source.created_at",
        width: "100%",
        accessor: (submission) => {
          return (
            <>
              <div className="row">
                <div className="col-6">
                  {this._renderSubmission(submission.source)}
                </div>
                <div className="col-6 r-sub">
                  {this._renderSubmission(submission)}
                </div>
              </div>
            </>
          );
        },
      },
    ];
  }

  render() {
    let {
      mode,
      imports,
      selectedSubmission,
      declarationEditable,
      showDeclarationModal,
    } = this.state;

    const columns = this._getColumns();

    return (
      <div className="linked-submissions-container">
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Submissions}?source_type=automated_import&expand_source=true`}
          noDataMessage={"No linked declarations found"}
          title={"Linked Declarations"}
          subtitle={this.props.subtitle}
          showPagination={true}
          columns={columns}
          filters={FILTERS}
          defaultSorted={[
            {
              id: "created_at",
              desc: true,
            },
          ]}
          filterButtonName="Import Filters"
          dateRange={false}
          collapseOnDataChange={false}
          renderTableInnerHeader={() => (
            <div className="row p-3">
              <div className="col-6">
                <h2>Export</h2>
              </div>
              <div className="col-6">
                <h2>Automated Import</h2>
              </div>
            </div>
          )}
        />

        {showDeclarationModal && (
          <Declaration
            show={showDeclarationModal}
            editable={declarationEditable}
            submission={selectedSubmission}
            onClose={() => {
              if (declarationEditable) {
                this.table.current.refresh();
              }
              this.setState({
                showDeclarationModal: false,
                selectedSubmission: null,
                declarationEditable: false,
              });
            }}
          />
        )}
      </div>
    );
  }
}

LinkedSubmissionsTable.defaultProps = {
  showDateRange: true,
  subtitle: "",
  mode: "declaration",
};

export default withRouter(LinkedSubmissionsTable);

